import React, {Component} from 'react';
import { FaWindows } from 'react-icons/fa';

class Login extends Component {
  constructor(props){
    super(props);

    this.handleAuthClick = this.handleAuthClick.bind(this);
  }

  handleAuthClick(e) {
    //redirect to azure for authentication
    window.location.href ='/auth/azure';
  }

  render(){
    return (
      <div className="login-content">
        <h1>Login</h1>
        <p>Use the button below to authenticate using your corporate account.</p>
        <button 
          onClick={this.handleAuthClick} 
          className="btn-auth btn-azure" 
          name="azure">
            <div className="button-icon"><FaWindows /></div> 
            Sign in with Microsoft
          </button>
      </div>
    );
  }
}

export default Login;